import styled from 'styled-components'

const ResponsiveTableWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px 0;

  table {
    min-width: 700px;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    border-collapse: collapse;
  }

  @media (max-width: 800px) {
    table {
      min-width: 500px;
    }
  }

  @media (max-width: 600px) {
    table {
      min-width: 350px;
      font-size: 12px;
    }
  }
`

export { ResponsiveTableWrapper }
